import Splide from '@splidejs/splide';

$(window).on('load', function() {
  slider();
})

function slider()  {
  new Splide( '.splide', {
    perPage: 1,
    rewind : true,
    autoplay: true,
    speed: 800,
    interval: 5000,
    pagination: false,
    arrows: false,
    pauseOnHover : false,
    pauseOnFocus : false
  }).mount();
}  
